import {PageMetaConfig} from '@spartacus/core';

export const DcpPageMetaConfig: PageMetaConfig = {
  pageMeta: {
    resolvers: [
      {
        property: 'title',
        method: 'resolveTitle',
      },
      {
        property: 'heading',
        method: 'resolveHeading',
      },
      {
        property: 'breadcrumbs',
        method: 'resolveBreadcrumbs',
      },
      {
        property: 'description',
        method: 'resolveDescription',
      },
      {
        property: 'image',
        method: 'resolveImage',
      },
      {
        property: 'robots',
        method: 'resolveRobots',
      },
      {
        property: 'canonicalUrl',
        method: 'resolveCanonicalUrl',
      },
    ],
  },
};
